import { render } from "./SkeletonImage.vue?vue&type=template&id=3ab1ec10&scoped=true&ts=true"
import script from "./skeleton-image.component.ts?vue&type=script&lang=ts&external"
export * from "./skeleton-image.component.ts?vue&type=script&lang=ts&external"

import "./skeleton-image.scss?vue&type=style&index=0&id=3ab1ec10&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab1ec10"]])

export default __exports__